import { render } from "./ComponentFilaDiretorio.vue?vue&type=template&id=fcbefe7e"
import script from "./ComponentFilaDiretorio.vue?vue&type=script&lang=js"
export * from "./ComponentFilaDiretorio.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__